import { render, staticRenderFns } from "./CohortEditTabInformation.vue?vue&type=template&id=6853e6ef&scoped=true&"
import script from "./CohortEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./CohortEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./CohortEditTabInformation.vue?vue&type=style&index=0&id=6853e6ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6853e6ef",
  null
  
)

export default component.exports